import { render, staticRenderFns } from "./alienatedEquip.vue?vue&type=template&id=64c3c322"
import script from "./alienatedEquip.vue?vue&type=script&lang=js"
export * from "./alienatedEquip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports